import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CarsPage from "@/pages/CarsPage";
import CarDetailPage from "@/pages/CarDetailPage";
import VendiPage from "@/pages/VendiPage";
import VendutePage from "@/pages/VendutePage";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import "@/App.css";

function ScrollToTop() {
  const loc = useLocation();
  useEffect(() => {
    // Handle in-page hash anchors
    if (loc.hash) {
      const el = document.querySelector(loc.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [loc.pathname, loc.hash]);
  return null;
}

function Layout({ children, chrome = true }) {
  return (
    <>
      <div className="grain-overlay" aria-hidden />
      {chrome && <Header />}
      <main>{children}</main>
      {chrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <SmoothScrollProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster richColors position="top-center" theme="dark" />
          <Routes>
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/vetture" element={<Layout><CarsPage /></Layout>} />
            <Route path="/vetture/:id" element={<Layout><CarDetailPage /></Layout>} />
            <Route path="/vendi" element={<Layout><VendiPage /></Layout>} />
            <Route path="/vendute" element={<Layout><VendutePage /></Layout>} />
            <Route path="/login" element={<Layout chrome={false}><LoginPage /></Layout>} />
            <Route path="/admin" element={<Layout chrome={false}><AdminPage /></Layout>} />
          </Routes>
        </BrowserRouter>
        </SmoothScrollProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
